import { render, staticRenderFns } from "./CourseCateList.vue?vue&type=template&id=94ae3930&"
import script from "./CourseCateList.vue?vue&type=script&lang=js&"
export * from "./CourseCateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports